module.exports = __webpack_public_path__ + "media/images/new_culture/approach-bg-084966c26c6a99a4a1885eb5c07baf4d.png";